<template lang="pug">
.reviews
  reviews-short(
    v-if="list.length > 0"
    :list="list"
    :show-avatars="avatars"
  ).reviews__list
  panel-simple(
    v-if="reviewPopup"
    @close="closePopup"
  ).reviews__panel
    .reviews__message(v-if="showMessage")
      app-spinner(v-if='showSpinner').reviews__spinner
      .reviews__wrap(v-else)
        h2(:class="{ error: error}").reviews__subheader
          | {{  error ? 'Отзыв не отправлен!' : thankText }}
        p
          | {{ error ? error : moderateText }}
    form-review(
      v-if="!showMessage"
      :title="title"
      :rating="rating"
      :userData="userData"
      :errorText="reviewError"
      :buttonText="formBtnText"
      :localReview="localReview"
      :placeholderText="placeholderText"
      :errorValidationText="errorValidationText"
      @submit="submitReview"
    )
  p(v-if="!auth").reviews__text
    | Оставить {{ blog ? 'комментарий' : 'отзыв'}} могут только зарегистрированные пользователи.
  .reviews__btn
    ext-button(
      :color="'default'"
      :size="'small'"
      :factor="1.4"
      :wide="true"
      :fill="auth"
      @click="eventComp"
    )
      | {{ !auth ? authText : text }}
</template>

<script>
import ReviewsShort from '@/components/parts/review/short';
import { PanelSimple } from 'elysium-common/components/panel';
import { Review as FormReview } from '@/components/parts/form';
import ExtButton from '@/components/ext/Button.vue';
import AppSpinner from '@/components/ext/Spinner_new.vue';

export default {
  components: {
    ReviewsShort,
    PanelSimple,
    FormReview,
    ExtButton,
    AppSpinner,
  },

  props: {
    reviewSuccess: {
      type: Boolean,
      default: false,
    },

    closeModal: {
      type: Boolean,
      default: false,
    },

    auth: {
      type: Boolean,
      default: false,
    },

    blog: {
      type: Boolean,
      default: false,
    },

    message: {
      type: Boolean,
      default: true,
    },

    avatars: {
      type: Boolean,
      default: false,
    },

    rating: {
      type: Boolean,
      default: true,
    },

    userData: {
      type: Object,
      default: null,
    },

    signinRoute: {
      type: String,
      default: '#entrance',
    },

    autoClose: {
      type: Boolean,
      default: false,
    },

    delay: {
      type: Number,
      default: 3000,
    },

    title: {
      type: String,
      default: 'Оставьте отзыв о программе',
    },

    thankText: {
      type: String,
      default: 'Спасибо, что вы с нами!',
    },

    errorValidationText: {
      type: String,
      default: 'Напишите отзыв',
    },

    placeholderText: {
      type: String,
      default: 'Ваш отзыв очень важен для нас',
    },

    moderateText: {
      type: String,
      default: 'Отзыв принят и появится на сайте после модерации!',
    },

    authText: {
      type: String,
      default: 'Авторизация',
    },

    compBtnText: {
      type: String,
      default: 'Оставить отзыв',
    },

    formBtnText: {
      type: String,
      default: 'Отправить',
    },

    reviewError: {
      type: String,
      default: '',
    },

    reviews: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    reviewPopup: false,
    showSpinner: true,
    showMessage: false,
    localReview: null,
    error: '',
    timer: null,
  }),

  computed: {
    list() {
      return this.reviews === null ? [] : this.reviews;
    },

    text() {
      return this.reviewPopup ? 'Закрыть' : this.compBtnText;
    },
  },

  watch: {
    reviewSuccess(value) {
      if (value) {
        this.serverHandler();
      }
    },

    closeModal(value) {
      if (value) {
        this.closePopup();
      }
    },

    reviewError(Value, oldValue) {
      if (Value) {
        this.error = Value;
        this.serverHandler();
      } else {
        this.error = oldValue;
      }
    },
  },

  beforeMount() {
    this.getLocalReview();
  },

  beforeDestroy() {
    this.clearTimeout();
    if (this.localReview) {
      this.clearLocalReview();
    }
  },

  methods: {
    eventComp() {
      if (!this.auth) {
        this.$router.push({ hash: this.signinRoute });
      } else if (this.reviewPopup) {
        this.closePopup();
      } else {
        this.openPopup();
      }
    },

    submitReview(fields) {
      const data = {
        ...fields,
      };
      this.$emit('submitReview', data);
      this.setLocalReview(data);
      this.showMessage = this.message;
    },

    serverHandler() {
      if (this.message) {
        this.infoHandler(this.autoClose);
      } else if (!this.reviewError) {
        this.closePopup();
      }
    },

    infoHandler(setTimer) {
      this.showSpinner = false;
      if (setTimer) {
        this.setTimer();
      }
    },

    openPopup() {
      this.reviewPopup = true;
      if (!this.localReview) {
        this.getLocalReview();
      }
    },

    closePopup() {
      this.reviewPopup = false;
      this.$emit('closePopup');
      if (this.message && this.showMessage) {
        this.showMessage = false;
      }
      if (!this.error) {
        this.clearLocalReview();
      }
      if (this.timer) {
        this.clearTimeout();
      }
    },

    setLocalReview(data) {
      const review = JSON.stringify(data);
      localStorage.setItem('review', review);
      this.localReview = data;
    },

    getLocalReview() {
      const storeage = localStorage.getItem('review');
      if (storeage) {
        this.localReview = JSON.parse(storeage);
      }
    },

    clearLocalReview() {
      localStorage.removeItem('review');
      this.localReview = null;
    },

    setTimer() {
      this.timer = setTimeout(() => {
        this.closePopup();
      }, this.delay);
    },

    clearTimeout() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = null;
    },
  },
};
</script>

<style lang="stylus" scoped>
$center
  margin auto

$text-center
  text-align center

.reviews
  &__list
    margin-bottom 33px !important
    border-bottom solid 1px #d3d4d9

  &__panel
    margin-bottom 55px
    padding 0

  &__message
    height 370px
    display flex

  &__spinner
    @extends $center
    width 100px
    height 100px
    display block

  &__wrap
    @extends $center
    @extends $text-center

  &__subheader
    margin-bottom 9px

  &__text
    @extends $text-center
    margin 0 auto -18px
    width 40%
    font-size 14px
    line-height 1.42
    color #666

  &__btn
    margin 40px auto 0
    max-width 300px

.error
  color red
</style>



// WEBPACK FOOTER //
// Reviews.vue?41e5e8c0